import React from "react";
import CorporateForm from "../components/CorporateForm";
import { IMAGES, CORPORATE_TOPICS } from "../data/content";
import SectionHeading from "../components/SectionHeading";
import useReveal from "../hooks/useReveal";

export default function CorporatePage() {
    useReveal();
    return (
        <div className="pt-24" data-testid="corporate-page">
            <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center ssh-reveal">
                    <div className="lg:col-span-7">
                        <SectionHeading
                            eyebrow="Corporate Wellness"
                            title="Emotional wellness &"
                            titleItalic="women-centric programs for organisations."
                            sub="Soul Sync Healing partners with companies to create sessions, workshops, and circles that support employee well-being, emotional resilience, burnout recovery, and mindful leadership."
                        />
                    </div>
                    <div className="lg:col-span-5">
                        <div className="aspect-[5/4] overflow-hidden">
                            <img
                                src={IMAGES.corporate}
                                alt="Workshop facilitation"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-[#EFEBE4]">
                <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
                    <div className="ssh-reveal">
                        <SectionHeading
                            eyebrow="Workshop Topics"
                            title="What we hold space for"
                            titleItalic="inside your team."
                        />
                    </div>
                    <ul className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#dfd9cc] border border-[#dfd9cc]">
                        {CORPORATE_TOPICS.map((t, i) => (
                            <li
                                key={t}
                                className="bg-[#EFEBE4] p-8 ssh-reveal"
                                style={{ transitionDelay: `${0.04 * i}s` }}
                            >
                                <p className="font-serif text-2xl text-[#2C2B29] leading-tight">
                                    {t}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section className="bg-white" id="inquiry">
                <div className="max-w-5xl mx-auto px-6 lg:px-12 py-20 lg:py-28 ssh-reveal">
                    <SectionHeading
                        eyebrow="Workshop Inquiry"
                        title="Bring this work to"
                        titleItalic="your team."
                        sub="Share a few details and we'll respond within 1–2 working days with thoughts on format, scope, and next steps."
                    />
                    <div className="mt-12">
                        <CorporateForm />
                    </div>
                </div>
            </section>
        </div>
    );
}
